import animationBlue from 'img/nestleLanding/animations/nickname/blue_mobile.riv';
import bgBlueMobile from 'img/nestleLanding/animations/nickname/blue_static_mobile.png';
import animationGreen from 'img/nestleLanding/animations/nickname/green_mobile.riv';
import bgGreenMobile from 'img/nestleLanding/animations/nickname/green_static_mobile.png';
import animationPink from 'img/nestleLanding/animations/nickname/pink_mobile.riv';
import bgPinkMobile from 'img/nestleLanding/animations/nickname/pink_static_mobile.png';
import animationRed from 'img/nestleLanding/animations/nickname/red_mobile.riv';
import bgRedMobile from 'img/nestleLanding/animations/nickname/red_static_mobile.png';
import { CardColor } from 'reactApp/sections/Nestle/PetsCard/PetsCard.types';

export const animations = {
    [CardColor.blue]: animationBlue,
    [CardColor.green]: animationGreen,
    [CardColor.red]: animationRed,
    [CardColor.pink]: animationPink,
};

export const backgroundImagesMobile = {
    [CardColor.blue]: bgBlueMobile,
    [CardColor.green]: bgGreenMobile,
    [CardColor.red]: bgRedMobile,
    [CardColor.pink]: bgPinkMobile,
};
